/* import __COLOCATED_TEMPLATE__ from './history.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { IHistoryRecord } from 'volta/routes/base';

interface BvAppSearchEntryHistorySignature {
  Args: {
    history: IHistoryRecord;
  };
}

const BvAppSearchEntryHistoryComponent = templateOnlyComponent<BvAppSearchEntryHistorySignature>();

export default BvAppSearchEntryHistoryComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvAppSearch::Entry::History': typeof BvAppSearchEntryHistoryComponent;
    'bv-app-search/entry/history': typeof BvAppSearchEntryHistoryComponent;
  }
}
